export default "__VITE_ASSET__BYY7iWlh__"